import { AddressSuggestion } from '../types/search.types';
import { apiClient } from '@/shared/api/client';

/**
 * Geocoding service using backend proxy to Azure Maps API
 */

interface GeocodeResult {
  id: string;
  type: string;
  score: number;
  address: {
    freeformAddress: string;
    municipality?: string;
    postalCode?: string;
    country?: string;
  };
  position: {
    lat: number;
    lon: number;
  };
}

export const geocodingService = {
  /**
   * Get address suggestions based on user input
   * @param input - User's search query
   * @returns List of address suggestions
   */
  async getAddressSuggestions(input: string): Promise<AddressSuggestion[]> {
    if (!input || input.length < 3) {
      return [];
    }

    try {
      const results = await apiClient.get<GeocodeResult[]>('/geocoding/search', {
        params: { query: input },
      });

      return results.map(item => ({
        description: item.address.freeformAddress,
        placeId: item.id,
        coordinates: {
          lat: item.position.lat,
          lng: item.position.lon,
        },
      }));
    } catch (error) {
      console.error('Error fetching address suggestions:', error);
      return [];
    }
  },

  /**
   * Get coordinates for a specific place ID
   * Note: With Azure Maps, coordinates are already included in the search results
   * This method is kept for backward compatibility
   * @param placeId - The place ID from a previous search
   * @returns Coordinates {lat, lng}
   */
  async getCoordinates(placeId: string): Promise<{ lat: number; lng: number } | null> {
    // Azure Maps includes coordinates in search results
    // This method is kept for backward compatibility but may not be needed
    console.warn('getCoordinates called with placeId:', placeId);
    return null;
  },
};
